import React from 'react'
import {
  Grid,
  Card,
  CardContent
} from '@material-ui/core'
import CustomText from '../Universal/CustomText'

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    height: 'auto',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    justifyContent: 'space-between',
    alignItems: 'center'
    // border: `2px solid ${theme.palette.secondary.main}`
  },
  icon: {
    padding: 10
  }
}))

export default function DashboardCard (props) {
  const classes = useStyles()
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card className={classes.card} style={{ padding: '12px 8px !important', }}>
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <CustomText text={props.title} style='cardMedium' />
            <CustomText text={props.subtitle} style='cardAmount' />
          </CardContent>
        </div>
        <div className={classes.icon}>
          {props.icon}
        </div>
      </Card>
    </Grid>
  )
}
